import { defineMessages } from 'react-intl';

export default defineMessages({
    signIn: {
        id: 'tdic.portal.app-error.sign in',
        defaultMessage: 'sign in'
    },
    AppErrorLink: {
        id: 'tdic.portal.app-error.Return to sign in.',
        defaultMessage: 'Return to {signIn}.'
    },
    appErrorUser: {
        id: 'tdic.portal.app-error.We are unable to process your request.',
        defaultMessage: 'We are unable to process your request.'
    },
    appErrorMessageInError: {
        id: 'tdic.portal.app-error.Please try re-entering your information or contact TDIC for assistance.',
        defaultMessage: 'Please try re-entering your information or contact TDIC for assistance.'
    }
});
